module.exports = __webpack_public_path__ + "static/Chubb1-edd816eb8026b407b2cd71dcc39cbab8.png";